import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { createDeferredLoadable } from '../../utils/createDeferredLoadable';
import { TRACKING_SOURCES, trackClickedLink, trackFaqInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const FAQS_BY_GROUP = {
  COMMERCE: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-commerce" */'pricing-pages-ui-components/frequentlyAskedQuestions/CommerceHubFaqs').then(m => ({
    default: m.CommerceHubFaqs
  }))),
  CONTENT: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-content" */'pricing-pages-ui-components/frequentlyAskedQuestions/ContentHubFaqs').then(m => ({
    default: m.ContentHubFaqs
  }))),
  DATA: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-data" */'pricing-pages-ui-components/frequentlyAskedQuestions/DataHubFaqs').then(m => ({
    default: m.DataHubFaqs
  }))),
  FREE: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-free" */'pricing-pages-ui-components/frequentlyAskedQuestions/FreeToolsFAQs').then(m => ({
    default: m.FreeToolsFAQs
  }))),
  MARKETING: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-marketing" */'pricing-pages-ui-components/frequentlyAskedQuestions/MarketingHubFaqs').then(m => ({
    default: m.MarketingHubFaqs
  }))),
  PLATFORM: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-suite" */'pricing-pages-ui-components/frequentlyAskedQuestions/CustomerPlatformFAQs').then(m => ({
    default: m.CustomerPlatformFAQs
  }))),
  SALES: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-sales" */'pricing-pages-ui-components/frequentlyAskedQuestions/SalesHubFaqs').then(m => ({
    default: m.SalesHubFaqs
  }))),
  SERVICE: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-service" */'pricing-pages-ui-components/frequentlyAskedQuestions/ServiceHubFaqs').then(m => ({
    default: m.ServiceHubFaqs
  }))),
  SMART_CRM: createDeferredLoadable(() => import( /* webpackChunkName: "public-faqs-smart-crm" */'pricing-pages-ui-components/frequentlyAskedQuestions/SmartCrmFaqs').then(m => ({
    default: m.SmartCrmFaqs
  })))
};
export const PublicFaqsSection = ({
  productGroup,
  screen
}) => {
  const sectionRef = useTrackSectionViewed(TRACKING_SOURCES.FAQ, screen);
  const FaqComponent = FAQS_BY_GROUP[productGroup];
  if (!FaqComponent) return null;
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FaqComponent, {
        onFaqInteraction: trackFaqInteraction,
        onLinkClick: props => trackClickedLink(Object.assign({}, props, {
          trackingSource: TRACKING_SOURCES.FAQ,
          screen
        }))
      })
    })
  });
};